﻿import * as signalR from '@microsoft/signalr';
import * as types from './NotificationType';

export default class NotificationHandler {
    constructor() {
        this.connection = null;
    }

    initConnection(rootURL) {
        this.connection = new signalR.HubConnectionBuilder().configureLogging(signalR.LogLevel.None).withUrl(rootURL + 'notification').build();
        this.connectionURL = this.connection.baseUrl;
        this.addHandlers();
        this.startConnection();

        let mapControl;

        if (window.mapCtrl == null) {
            let maps = Array.from(document.getElementsByClassName('xp-map'));
            maps.forEach(map => {
                mapControl = map.mapControl;
            });
        } else {
            mapControl = window.mapCtrl;
        }

        window.xpMapCtrl = mapControl;
    }

    updateLayout(connectionId, themeName, fontSizeClass) {
        this.sendMessage(connectionId, types.UPDATE_LAYOUT, { "Theme": themeName, "FontSizeClass": fontSizeClass });
    }

    modalWindowHasClosed(connectionId) {
        this.sendMessage(connectionId, types.MODAL_WINDOW_HAS_CLOSED, null);
    }

    wfDisplayed(connectionId) {
        this.sendMessage(connectionId, types.WF_DISPLAYED, null);
    }

    getCurrentURL(connectionId, callback) {
        if (callback) {
            this.frame_currentURL_callback = callback;
            this.sendMessage(connectionId, types.GET_CURRENT_URL, null);
        }
    }

    sendMessage(toToken, command, parameters) {
        this.connection.send("SendMessage",null, toToken, command,parameters);
    }

    addHandlers() {
        this.connection.onclose((res) => { this.startConnection(); });

        this.connection.on('message', (res) => {
            var result = JSON.parse(res);

            var command = result.Command;
            var commandParams = result.Parameters;

            switch (command) {
                case types.USER_NOTIFICATION:
                    let type = commandParams.Details.NotifType;
                    switch (type) {
                        case types.USER_NOTIFICATION_POPUP: {
                            let title = commandParams.Details.Title;
                            let body = commandParams.Details.Body;

                            confirmDialog.fire({ html: '<div style="text-align: start;">' + this.fromTextToHTML(body) + '</div>', title: title, showCancelButton: false, confirmButtonText: 'OK', allowOutsideClick: false }).then((result) => { });
                            break;
                        }
                        default: break;
                    }
                    break;
                case types.SUCCESS:
                    toastr.success(this.fromTextToHTML(commandParams.Message), commandParams.Title);
                    break;
                case types.WARNING:
                    toastr.warning(this.fromTextToHTML(commandParams.Message), commandParams.Title);
                    break;
                case types.ERROR:
                    {
                        var details = commandParams.Details;
                        var title = null;
                        if (details != null) {
                            title = details.Title;
                        }

                        var log = '';
                        if (commandParams.Message != null && commandParams.Message != '') {
                            if (log != '') {
                                log += "; ";
                            }
                            log += commandParams.Message;
                        }
                        if (title != null && title != '') {
                            if (log != '') {
                                log += "; ";
                            }
                            log += title;
                        }
                        console.log(log);
                        toastr.error(this.fromTextToHTML(commandParams.Message), title);
                    }
                    break
                case types.MESSAGE:
                    {
                        var details = commandParams.Details;
                        var title = 'Atenție';
                        if (details != null) {
                            title = details.Title;
                        }
                    }
                    confirmDialog.fire({ html: '<div style="text-align: start;">' + this.fromTextToHTML(commandParams.Message) + '</div>', title: title, showCancelButton: false, confirmButtonText: 'OK' });
                    break;
                case types.ALERT_SUCCESS:
                    $event.notify("showAlert", { type: "success", icon: commandParams.Icon, content: commandParams.Content }, this);
                    break;
                case types.ALERT_INFO:
                    $event.notify("showAlert", { type: "info", icon: commandParams.Icon, content: commandParams.Content }, this);
                    break;
                case types.ALERT_WARNING:
                    $event.notify("showAlert", { type: "warning", icon: commandParams.Icon, content: commandParams.Content }, this);
                    break;
                case types.ALERT_ERROR:
                    $event.notify("showAlert", { type: "danger", icon: commandParams.Icon, content: commandParams.Content }, this);
                    break;
                case types.HIDE_ALERT:
                    $event.notify("hideAlert",null, this);
                    break;

                case types.SHOW_ALERT:
                    Swal.fire({
                        allowOutsideClick: false,
                        title: commandParams.Title,
                        html: commandParams.Content
                    });
                    break;
                case types.SHOW_LOADING_PANEL:
                    showLoadingPanel();
                    break;

                case types.HIDE_LOADING_PANEL:
                    hideLoadingPanel();
                    break;

                case types.FINISH_LOADING:
                    $event.notify("loadingFinish", { wfConnectionId: commandParams.ConnectionId }, this);
                    break;
                case types.SIZE_CHANGED:
                    $event.notify("sizeChanged", { width: commandParams.Width, height: commandParams.Height }, this);
                    break;
                case types.MODAL_SIZE_CHANGED:
                  
                    $event.notify("modalSizeChanged", { width: commandParams.Width, height: commandParams.Height }, this);
                    break;
                case types.SHOW_FEATURE:
                    if (xpMapCtrl != null) {

                        var callbackSuccess = function () {
                            hideLoadingPanel();
                        }
                        var callbackError = function (e) {
                            hideLoadingPanel();
                            toastr.error(e, "Error");
                        }

                        var entityId = commandParams.EntityId;
                        let layerId;

                        if (entityId != null) {
                            var layers = xpMapCtrl.layerSettingsHandler.getLayerSettingsByEntityId(entityId);
                            if (layers != null && layers.length > 0) {
                                layerId = layers[0].Id;
                            }
                        } else if (entityId == null && commandParams.LayerName != null && commandParams.LayerName.trim() != "") {
                            var layers = xpMapCtrl.layerSettingsHandler.getLayerSettingsByName(commandParams.LayerName.trim());
                            if (layers != null && layers.length > 0) {
                                layerId = layers[0].Id;
                            }
                        }

                        if (layerId) {
                            xpMapCtrl.showFeatures(layerId, commandParams.FeatureIds,
                                parseInt(commandParams.Scale), callbackSuccess, callbackError);
                        }
                    }
                    break;
                case types.CENTER_MAP:
                    if (xpMapCtrl != null) {
                        xpMapCtrl.center(JSON.parse(commandParams.PointCoordinates), commandParams.Scale, commandParams.ProjectionCode);
                    }
                    break;
                case types.SHOW_TEMPORARY_POINT:
                    //TODO
                    if (xpMapCtrl != null) {
                        xpMapCtrl.showTemporaryFeature("tempPoint", JSON.parse(commandParams.PointCoordinates), commandParams.Scale, commandParams.ProjectionCode, commandParams.Style, false);
                        const ref = this;
                        this.tempPoint_onModalWindowClose = function (eventName, event, sender) {
                            xpMapCtrl.clearTemporaryLayer("tempPoint");
                            $event.unregister("modalWindowClose", ref.tempPoint_onModalWindowClose, $(xpMapCtrl.target)[0]);
                            ref.tempPoint_onModalWindowClose = null;
                        }
                        $event.register("modalWindowClose", this.tempPoint_onModalWindowClose, $(xpMapCtrl.target)[0]);
                    }
                    break;
                case types.REFRESH_LAYER:
                    if (xpMapCtrl != null) {

                        var entityId = commandParams.EntityId;
                        let layerId;

                        if (entityId != null) {
                            var layers = xpMapCtrl.layerSettingsHandler.getLayerSettingsByEntityId(entityId);
                            if (layers != null && layers.length > 0) {
                                layerId = layers[0].Id;
                            }
                        } else if (entityId == null && commandParams.LayerName != null && commandParams.LayerName.trim() != "") {
                            var layers = xpMapCtrl.layerSettingsHandler.getLayerSettingsByName(commandParams.LayerName.trim());
                            if (layers != null && layers.length > 0) {
                                layerId = layers[0].Id;
                            }
                        }

                        if (layerId) {
                            xpMapCtrl.refreshLayer(layerId);
                        }
                    }
                    break;
                case types.GET_SELECTED_FEATURES:
                    if (xpMapCtrl != null) {
                        var connectionId = commandParams.ConnectionId;
                        var selectedFeatures = xpMapCtrl.getSelectedFeatures();
                        this.sendMessage(connectionId, types.SELECTED_FEATURES, {
                            LayerId: selectedFeatures == null ? null : selectedFeatures.layerId, LayerName: selectedFeatures == null ? null : selectedFeatures.layerName,
                            SelectedFeatures: selectedFeatures == null ? null : JSON.stringify(selectedFeatures.selectedFeatures)
                        });

                    }
                    break;
                case types.GET_POINT_COORDINATES:
                    //TODO
                    if (xpMapCtrl != null) {
                        var connectionId = commandParams.ConnectionId;
                        $("a.navItem").addClass("disabled");
                        $("a.navItem").parent().addClass("disabled");
                        $("a.map-menu-item:not(.always-active)").addClass("disabled");

                        if (modalWindow != null) {
                            modalWindow.wrapper.hide();
                        }
                        var callback = (coordinates) => {

                            if (modalWindow != null) {
                                modalWindow.wrapper.show();
                            }

                            $("a.navItem").removeClass("disabled");
                            $("a.navItem").parent().removeClass("disabled");
                            $("a.map-menu-item:not(.always-active)").removeClass("disabled");

                            this.sendMessage(connectionId, types.POINT_COORDINATES, {
                                Coordinates: coordinates == null ? null : JSON.stringify(coordinates)
                            });
                        }
                        xpMapCtrl.getPointCoordinates(commandParams.ProjectionCode, callback);
                    }
                    break;
                case types.EDIT_FEATURE_GEOMETRY_START:
                    if (xpMapCtrl != null) {

                        var entityId = commandParams.EntityId;
                        let layerId;

                        if (entityId != null) {
                            var layers = xpMapCtrl.layerSettingsHandler.getLayerSettingsByEntityId(entityId);
                            if (layers != null && layers.length > 0) {
                                layerId = layers[0].Id;
                            }
                        } else if (entityId == null && commandParams.LayerName != null && commandParams.LayerName.trim() != "") {
                            var layers = xpMapCtrl.layerSettingsHandler.getLayerSettingsByName(commandParams.LayerName.trim());
                            if (layers != null && layers.length > 0) {
                                layerId = layers[0].Id;
                            }
                        }

                        const connectionId = commandParams.ConnectionId;
                        const ref = this;
                        let featureInteractionControl = xpMapCtrl.generalActionHandler.generalActionControls.editControl;

                        var editFeature_callbackSave = function (response) {
                            ref.sendMessage(connectionId, types.EDIT_FEATURE_GEOMETRY_SAVE, { GeometryWKT: (response != null && response.features != null && response.features.length > 0) ? response.features[0].geom : null });
                        }

                        var editFeature_callbackCancel = function () {
                            ref.sendMessage(connectionId, types.EDIT_FEATURE_GEOMETRY_CANCEL, null);
                        }

                        var selectFeature_callbackSuccess = function () {
                            hideLoadingPanel();
                            featureInteractionControl.startEdit(layerId, null, editFeature_callbackSave, editFeature_callbackCancel)
                        }

                        var selectFeature_callbackError = function (e) {
                            hideLoadingPanel();
                            ref.sendMessage(connectionId, types.EDIT_FEATURE_GEOMETRY_NO_FEATURE, { Error: e });
                        }

                        if (this.modalWindowCloseHandler == null) {
                            this.modalWindowCloseHandler = function (eventName, eventArgs, sender) {

                                if (xpMapCtrl != null && featureInteractionControl != null) {
                                    featureInteractionControl.stopEdit();
                                }
                                $event.unregister("modalWindowClose", ref.modalWindowCloseHandler, $(xpMapCtrl.target)[0]);
                                ref.modalWindowCloseHandler = null;
                            }

                            $event.register("modalWindowClose", ref.modalWindowCloseHandler, $(xpMapCtrl.target)[0]);
                        }

                        xpMapCtrl.showFeatures(layerId, commandParams.FeatureId != null && !isNaN(commandParams.FeatureId) ? parseInt(commandParams.FeatureId) : commandParams.FeatureId,
                            null, selectFeature_callbackSuccess, selectFeature_callbackError);
                    }
                    break;
                case types.EDIT_FEATURE_GEOMETRY_STOP:
                    if (xpMapCtrl != null) {
                        let featureInteractionControl = xpMapCtrl.generalActionHandler.generalActionControls.editControl;
                        featureInteractionControl.stopEdit();
                    }
                    if (this.modalWindowCloseHandler == null) {
                        $event.unregister("modalWindowClose", this.modalWindowCloseHandler, $(mapControl.target)[0]);
                        this.modalWindowCloseHandler = null;
                    }
                    break;

                case types.INSERT_FEATURE_GEOMETRY_START:
                    if (xpMapCtrl != null) {
                        var entityId = commandParams.EntityId;
                        let layerId;

                        if (entityId != null) {
                            var layers = xpMapCtrl.layerSettingsHandler.getLayerSettingsByEntityId(entityId);
                            if (layers != null && layers.length > 0) {
                                layerId = layers[0].Id;
                            }
                        } else if (entityId == null && commandParams.LayerName != null && commandParams.LayerName.trim() != "") {
                            var layers = xpMapCtrl.layerSettingsHandler.getLayerSettingsByName(commandParams.LayerName.trim());
                            if (layers != null && layers.length > 0) {
                                layerId = layers[0].Id;
                            }
                        }

                        const connectionId = commandParams.ConnectionId;
                        const ref = this;
                        let featureInteractionControl = xpMapCtrl.generalActionHandler.generalActionControls.editControl;

                        var insertFeature_callbackSave = function (response) {
                            ref.sendMessage(connectionId, types.INSERT_FEATURE_GEOMETRY_SAVE, { GeometryWKT: (response != null && response.features != null && response.features.length > 0) ? response.features[0].geom : null });
                        }

                        var insertFeature_callbackCancel = function () {
                            ref.sendMessage(connectionId, types.INSERT_FEATURE_GEOMETRY_CANCEL, null);
                        }
                        featureInteractionControl.startInsert(layerId, insertFeature_callbackSave, insertFeature_callbackCancel);

                        if (this.modalWindowCloseHandler == null) {
                            this.modalWindowCloseHandler = function (eventName, eventArgs, sender) {

                                if (xpMapCtrl != null && featureInteractionControl != null) {
                                    featureInteractionControl.stopInsert();
                                }
                                $event.unregister("modalWindowClose", ref.modalWindowCloseHandler, $(xpMapCtrl.target)[0]);
                                ref.modalWindowCloseHandler = null;
                            }

                            $event.register("modalWindowClose", ref.modalWindowCloseHandler, $(xpMapCtrl.target)[0]);
                        }

                    }
                    break;
                case types.INSERT_FEATURE_GEOMETRY_STOP:
                    if (xpMapCtrl != null) {
                        let featureInteractionControl = xpMapCtrl.generalActionHandler.generalActionControls.editControl;
                        featureInteractionControl.stopInsert();
                    }
                    if (this.modalWindowCloseHandler) {
                        $event.unregister("modalWindowClose", this.modalWindowCloseHandler, $(mapControl.target)[0]);
                        this.modalWindowCloseHandler = null;
                    }
                    break;
                case types.MINIMIZE_MODAL_WINDOW:
                    if (modalWindow != null) {
                        modalWindow.minimize();
                    }
                    break;
                case types.CLOSE_MODAL_WINDOW:
                    if (modalWindow != null) {
                        modalWindow.close();
                    }
                    break;
                case types.REDIRECT:
                    if (modalWindow != null) {
                        modalWindow.close();
                    }
                    window.location = commandParams.RedirectURL;
                    break;
                case types.SET_PANEL_HEADER:
                    if (window.updatePanelHeader != null) {
                        updatePanelHeader(commandParams.Title, commandParams.Icon);
                    }
                    break;
                case types.SHOW_MODAL_WINDOW:
                    if (commandParams.Url != null) {
                        commandParams.Url += "&theme=" + themeName;
                        commandParams.Url += "&modal=true";
                        var fontSizeClass = String($("html")[0].className).split(/[^\w-]+/).filter(function (item) { return /^(root-text)-/i.test(item); });
                        if (fontSizeClass.length > 0) { 
                            commandParams.Url += "&fontSize=" + fontSizeClass[0];
                        };
                        showModalWindow(commandParams.Url, commandParams.Title == null ? "" : commandParams.Title, commandParams.Icon, commandParams.Width, commandParams.Height);
                        $("#modalForm iframe").css({ 'max-height': "100%" });
                    }
                    break;
                case types.MODAL_FINISH_LOADING:
                    $event.notify("modalLoadingFinish", { wfConnectionId: commandParams.ConnectionId }, this);
                    break;
                case types.SHOW_CONFIRM:

                    const _confirmConnection = commandParams.ConnectionId;
                    confirmDialog.fire({
                        title: commandParams.Title,
                        text: commandParams.Content,
                    }).then( (result) => {
                        if (result.value) {
                            this.sendMessage(_confirmConnection, types.CONFIRM_YES, null);
                        }
                        else {
                            this.sendMessage(_confirmConnection, types.CONFIRM_NO, null);
                        }
                    });

                    break;
                case types.CURRENT_URL:
                    if (this.frame_currentURL_callback) {
                        this.frame_currentURL_callback(commandParams.CurrentURL);
                        this.frame_currentURL_callback = null;
                    }
                    break;
                default:
                    alert('Unimplemented notification type -> ' + key);
                    break;
            }
        });
    }

    startConnection() {

        var _startConn =  () => {
            this.startConnection();
        }

        this.connection.baseUrl = this.connectionURL;
        this.connection.start().then(() => {
            $event.notify("notificationConnectionChanged", { connectionId: this.connection.connectionId }, this);
        }).catch(function(e) {           
            setTimeout(_startConn, 1000);
        });

        Object.defineProperty(window.WebSocket, 'OPEN', { value: 1, });
    }

    closeConnection() {
     
        this.connection.closedCallbacks.pop();
        this.connection.stop();
    }

    fromTextToHTML(msg) {

        var fromList = ["\n", "\t"];
        var toList = ["<br\>", "&nbsp;&nbsp;&nbsp;&nbsp;"];

        for (var i = 0; i < fromList.length; i++) {
            while (msg.indexOf(fromList[i]) > -1) {
                msg = msg.replace(fromList[i], toList[i]);
            }
        }

        return msg;
    }

    changeWFTheme() {

    }
}